import * as React from 'react'
import { useAppSelector } from '../../../../../reducers'

interface UseDefaultValuesOutput {
    chains: number[];
}

function useDefaultValues(): UseDefaultValuesOutput {
    const chains = useAppSelector((state) => state.chains.chains)

    /**
     * Initial values for the filters form
     */
    return {
        chains: React.useMemo(() => {
            return chains.map(chain => chain.id)
        }, [chains]),
    }
}

export default useDefaultValues
